import { map } from 'lodash';
const formatRanking = (item) => {
    const {
        value = []
    } = item;
    return {
        ...item,
        isLoading: false,
        value
    };
};

export default function (data) {
    if (Array.isArray(data)) {
        return map(data, (item) => {
            return formatRanking(item);
        });
    }
    return formatRanking(data);
}
